import { render, staticRenderFns } from "./ModalResetOtpConfirm.vue?vue&type=template&id=4f2d8d4c&scoped=true&"
import script from "./ModalResetOtpConfirm.vue?vue&type=script&lang=js&"
export * from "./ModalResetOtpConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ModalResetOtpConfirm.vue?vue&type=style&index=0&id=4f2d8d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d8d4c",
  null
  
)

export default component.exports